module.exports = __webpack_public_path__ + "img/bank.450aca4b.svg";